<template>
  <Transition
    :enter-from-class="ui.animation.from"
    :enter-to-class="ui.animation.to"
    :enter-active-class="ui.animation.active"
    :leave-active-class="ui.animation.active"
    :leave-to-class="ui.animation.from"
    :leave-from-class="ui.animation.to"
  >
    <div v-if="show && hasSelections" :class="ui.root">
      <AwBulkAction :count="count" :class="ui.modal" :actions="actions" @unselect="unselect" />
    </div>
  </Transition>
</template>

<script setup lang="ts" generic="T extends Record<string, any>">
import type { AwBulkActionProps } from "@asap/design";

export type BulkActionType = "hiring_pool" | "mission";

defineProps<{
  actions: AwBulkActionProps["actions"];
  show: boolean;
}>();

const count = computed(() => {
  return bulkItems.value.length ?? Object.keys(selection.value).length;
});

const selection = defineModel<Record<string, any>>("selection", { default: () => ({}), required: true });
const bulkItems = defineModel<T[]>("bulkItems", { default: () => [] });

const hasSelections = computed(() => {
  return (bulkItems.value.length ?? 0) > 0 || Object.keys(selection.value).length > 0;
});

const unselect = () => {
  selection.value = {};
  bulkItems.value = [];
};

const ui = {
  animation: {
    from: "opacity-0 translate-y-10",
    to: "opacity-100 translate-y-0",
    active: "transition-all duration-100",
  },
  root: "absolute bottom-13 left-1/2 -translate-x-1/2",
  modal: "shadow-lg",
};
</script>
